import { useEffect, useRef, useContext, useState } from "react"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import SubstanceUse1 from "../Forms/B/SubstanceUse/SubstanceUse1"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const SubstanceUse1Container = ({ showToolBar, disabled, interview_id }) => {
  const { interview, handleSubmitGet, loadCollection, handleLoadPrev } =
    useContext(GpraContext)

  const userCtx = useContext(UserContext)

  const [isGettingSubstanceUse, setIsGettingSubstanceUse] = useState(true)

  const toast = useRef()

  useEffect(() => {
    if (
      interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id ||
      interview_id
    ) {
      setIsGettingSubstanceUse(true)
      handleSubmitGet(endpoints.GET_SUBSTANCE_USE_DATA, {
        gpra_interview_id: interview_id
          ? interview_id
          : interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.SUBSTANCE_USE_1,
      })
        .then((response) => {
          loadCollection(
            setValues(response.data),
            INTERVIEW_SECTIONS.SUBSTANCE_USE_1
          )
          handleLoadPrev(false)
          setIsGettingSubstanceUse(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    userCtx.session.user.organization_id,
    handleLoadPrev,
    handleSubmitGet,
    loadCollection,
    interview,
  ])

  const setValues = (data) => {
    return {
      ...data?.form,
      gpra_b_1a1_days: data?.form?.gpra_b_1a1_days ?? 0,
      gpra_b_1a1_route: data?.form?.gpra_b_1a1_route ?? 0,
      gpra_b_1a2_days: data?.form?.gpra_b_1a2_days ?? 0,
      gpra_b_1a2_route: data?.form?.gpra_b_1a2_route ?? 0,
      gpra_b_1a2a: data?.form?.gpra_b_1a2a ?? "",
      gpra_b_1b1_days: data?.form?.gpra_b_1b1_days ?? 0,
      gpra_b_1b1_route: data?.form?.gpra_b_1b1_route ?? 0,
      gpra_b_1b2_days: data?.form?.gpra_b_1b2_days ?? 0,
      gpra_b_1b2_route: data?.form?.gpra_b_1b2_route ?? 0,
      gpra_b_1b3_days: data?.form?.gpra_b_1b3_days ?? 0,
      gpra_b_1b3_route: data?.form?.gpra_b_1b3_route ?? 0,
      gpra_b_1b4_days: data?.form?.gpra_b_1b4_days ?? 0,
      gpra_b_1b4_route: data?.form?.gpra_b_1b4_route ?? 0,
      gpra_b_1b5_days: data?.form?.gpra_b_1b5_days ?? 0,
      gpra_b_1b5_route: data?.form?.gpra_b_1b5_route ?? 0,
      gpra_b_1b6_days: data?.form?.gpra_b_1b6_days ?? 0,
      gpra_b_1b6_route: data?.form?.gpra_b_1b6_route ?? 0,
      gpra_b_1b7_days: data?.form?.gpra_b_1b7_days ?? 0,
      gpra_b_1b7_route: data?.form?.gpra_b_1b7_route ?? 0,
      gpra_b_1b8_days: data?.form?.gpra_b_1b8_days ?? 0,
      gpra_b_1b8_route: data?.form?.gpra_b_1b8_route ?? 0,
      gpra_b_1b9_days: data?.form?.gpra_b_1b9_days ?? 0,
      gpra_b_1b9_route: data?.form?.gpra_b_1b9_route ?? 0,
      gpra_b_1b10_days: data?.form?.gpra_b_1b10_days ?? 0,
      gpra_b_1b10_route: data?.form?.gpra_b_1b10_route ?? 0,
      gpra_b_1b11_days: data?.form?.gpra_b_1b11_days ?? 0,
      gpra_b_1b11_route: data?.form?.gpra_b_1b11_route ?? 0,
      gpra_b_1b12_days: data?.form?.gpra_b_1b12_days ?? 0,
      gpra_b_1b12_route: data?.form?.gpra_b_1b12_route ?? 0,
      gpra_b_1b12a: data?.form?.gpra_b_1b12a ?? "",
      gpra_b_1c1_days: data?.form?.gpra_b_1c1_days ?? 0,
      gpra_b_1c1_route: data?.form?.gpra_b_1c1_route ?? 0,
      gpra_b_1c2_days: data?.form?.gpra_b_1c2_days ?? 0,
      gpra_b_1c2_route: data?.form?.gpra_b_1c2_route ?? 0,
      gpra_b_1c3_days: data?.form?.gpra_b_1c3_days ?? 0,
      gpra_b_1c3_route: data?.form?.gpra_b_1c3_route ?? 0,
      gpra_b_1c3a: data?.form?.gpra_b_1c3a ?? "",
      gpra_b_1d1_days: data?.form?.gpra_b_1d1_days ?? 0,
      gpra_b_1d1_route: data?.form?.gpra_b_1d1_route ?? 0,
      gpra_b_1d2_days: data?.form?.gpra_b_1d2_days ?? 0,
      gpra_b_1d2_route: data?.form?.gpra_b_1d2_route ?? 0,
      gpra_b_1d3_days: data?.form?.gpra_b_1d3_days ?? 0,
      gpra_b_1d3_route: data?.form?.gpra_b_1d3_route ?? 0,
      gpra_b_1d4_days: data?.form?.gpra_b_1d4_days ?? 0,
      gpra_b_1d4_route: data?.form?.gpra_b_1d4_route ?? 0,
      gpra_b_1d5_days: data?.form?.gpra_b_1d5_days ?? 0,
      gpra_b_1d5_route: data?.form?.gpra_b_1d5_route ?? 0,
      gpra_b_1d5a: data?.form?.gpra_b_1d5a ?? "",
      gpra_b_1e1_days: data?.form?.gpra_b_1e1_days ?? 0,
      gpra_b_1e1_route: data?.form?.gpra_b_1e1_route ?? 0,
      gpra_b_1e2_days: data?.form?.gpra_b_1e2_days ?? 0,
      gpra_b_1e2_route: data?.form?.gpra_b_1e2_route ?? 0,
      gpra_b_1e3_days: data?.form?.gpra_b_1e3_days ?? 0,
      gpra_b_1e3_route: data?.form?.gpra_b_1e3_route ?? 0,
      gpra_b_1e3a: data?.form?.gpra_b_1e3a ?? "",
      gpra_b_1f1_days: data?.form?.gpra_b_1f1_days ?? 0,
      gpra_b_1f1_route: data?.form?.gpra_b_1f1_route ?? 0,
      gpra_b_1f2_days: data?.form?.gpra_b_1f2_days ?? 0,
      gpra_b_1f2_route: data?.form?.gpra_b_1f2_route ?? 0,
      gpra_b_1f3_days: data?.form?.gpra_b_1f3_days ?? 0,
      gpra_b_1f3_route: data?.form?.gpra_b_1f3_route ?? 0,
      gpra_b_1f3a: data?.form?.gpra_b_1f3a ?? "",
      gpra_b_1g1_days: data?.form?.gpra_b_1g1_days ?? 0,
      gpra_b_1g1_route: data?.form?.gpra_b_1g1_route ?? 0,
      gpra_b_1g2_days: data?.form?.gpra_b_1g2_days ?? 0,
      gpra_b_1g2_route: data?.form?.gpra_b_1g2_route ?? 0,
      gpra_b_1g3_days: data?.form?.gpra_b_1g3_days ?? 0,
      gpra_b_1g3_route: data?.form?.gpra_b_1g3_route ?? 0,
      gpra_b_1g4_days: data?.form?.gpra_b_1g4_days ?? 0,
      gpra_b_1g4_route: data?.form?.gpra_b_1g4_route ?? 0,
      gpra_b_1g5_days: data?.form?.gpra_b_1g5_days ?? 0,
      gpra_b_1g5_route: data?.form?.gpra_b_1g5_route ?? 0,
      gpra_b_1g6_days: data?.form?.gpra_b_1g6_days ?? 0,
      gpra_b_1g6_route: data?.form?.gpra_b_1g6_route ?? 0,
      gpra_b_1g7_days: data?.form?.gpra_b_1g7_days ?? 0,
      gpra_b_1g7_route: data?.form?.gpra_b_1g7_route ?? 0,
      gpra_b_1g8_days: data?.form?.gpra_b_1g8_days ?? 0,
      gpra_b_1g8_route: data?.form?.gpra_b_1g8_route ?? 0,
      gpra_b_1g8a: data?.form?.gpra_b_1g8a ?? "",
      gpra_b_1h1_days: data?.form?.gpra_b_1h1_days ?? 0,
      gpra_b_1h1_route: data?.form?.gpra_b_1h1_route ?? 0,
      gpra_b_1h2_days: data?.form?.gpra_b_1h2_days ?? 0,
      gpra_b_1h2_route: data?.form?.gpra_b_1h2_route ?? 0,
      gpra_b_1h2a: data?.form?.gpra_b_1h2a ?? "",
      gpra_b_1i1_days: data?.form?.gpra_b_1i1_days ?? 0,
      gpra_b_1i1_route: data?.form?.gpra_b_1i1_route ?? 0,
      gpra_b_1i2_days: data?.form?.gpra_b_1i2_days ?? 0,
      gpra_b_1i2_route: data?.form?.gpra_b_1i2_route ?? 0,
      gpra_b_1i3_days: data?.form?.gpra_b_1i3_days ?? 0,
      gpra_b_1i3_route: data?.form?.gpra_b_1i3_route ?? 0,
      gpra_b_1i4_days: data?.form?.gpra_b_1i4_days ?? 0,
      gpra_b_1i4_route: data?.form?.gpra_b_1i4_route ?? 0,
      gpra_b_1i5_days: data?.form?.gpra_b_1i5_days ?? 0,
      gpra_b_1i5_route: data?.form?.gpra_b_1i5_route ?? 0,
      gpra_b_1i6_days: data?.form?.gpra_b_1i6_days ?? 0,
      gpra_b_1i6_route: data?.form?.gpra_b_1i6_route ?? 0,
      gpra_b_1i6a: data?.form?.gpra_b_1i6a ?? "",
      gpra_b_1i7_days: data?.form?.gpra_b_1i7_days ?? 0,
      gpra_b_1i7_route: data?.form?.gpra_b_1i7_route ?? 0,
      gpra_b_1i7a: data?.form?.gpra_b_1i7a ?? "",
      gpra_b_1i8_days: data?.form?.gpra_b_1i8_days ?? 0,
      gpra_b_1i8_route: data?.form?.gpra_b_1i8_route ?? 0,
      gpra_b_1i8a: data?.form?.gpra_b_1i8a ?? "",
      gpra_b_1i9_days: data?.form?.gpra_b_1i9_days ?? 0,
      gpra_b_1i9_route: data?.form?.gpra_b_1i9_route ?? 0,
      gpra_b_1i9a: data?.form?.gpra_b_1i9a ?? "",
      gpra_b_1i10_days: data?.form?.gpra_b_1i10_days ?? 0,
      gpra_b_1i10_route: data?.form?.gpra_b_1i10_route ?? 0,
      gpra_b_1i10a: data?.form?.gpra_b_1i10a ?? "",
      gpra_b_1j1_days: data?.form?.gpra_b_1j1_days ?? 0,
      gpra_b_1j1_route: data?.form?.gpra_b_1j1_route ?? 0,
      gpra_b_1j2_days: data?.form?.gpra_b_1j2_days ?? 0,
      gpra_b_1j2_route: data?.form?.gpra_b_1j2_route ?? 0,
      gpra_b_1j3_days: data?.form?.gpra_b_1j3_days ?? 0,
      gpra_b_1j3_route: data?.form?.gpra_b_1j3_route ?? 0,
      gpra_b_1j3a: data?.form?.gpra_b_1j3a ?? "",
      gpra_b_id: data?.form?.gpra_b_id ?? 0,
      additional: data?.additional ?? [],
    }
  }

  if (isGettingSubstanceUse) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingSubstanceUse && (
        <SubstanceUse1 showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default SubstanceUse1Container
